import React, { useState, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import BtnCellRenderer from "../common/BtnCellRenderer";
import {
  patientActions,
  doctorActions,
  tokenActions,
} from "../../core/actions";
import bookingplanService, { boardPatient } from "../../core/services/bookingplanService";
import Components from "..";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { addMonths, format, isBefore, isSameDay, parseISO } from "date-fns";
import { useHistory } from "react-router-dom";
import { helperServices } from "../../shared/helper";
import personDetailsService from "../../core/services/personDetailsService";
import { useOrganization } from "../../configurations/OrganizationContext";
import {
ORG_CODES
} from "../../shared/constants";
import {
  BASIC,
  PRE_AUTH_REQUEST,
  PRE_AUTH_RESPONSE,
  CLAIM_REQUEST,
  CLAIM_APPROVAL,
  INVOICE,
  BILLCLEAR,
} from "../../shared/constants";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { PATIENT_SECTION } from "../../shared/constants";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { set } from "lodash";
import { VALIDATE_STRING_FORCLOSE } from "../../core/constants/erpConstants";
import Badge, { statusVariant } from "../appointments/ui/Badge";
import "../appointments/styles/appointments.css";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function PatientListing(props) {
  const org = useOrganization();
  const DEFAULT_PAGE_SIZE = 16;
const [forceCloseCommentError, setForceCloseCommentError] = useState("");
  const [customerGroup, setCustomerGroup] = useState([]);
  const [aadharValue, setAadharValue] = useState("");
  const [aadharError, setAadharError] = useState("");
  const history = useHistory();
  const [pagination, setPagination] = useState(true);
  const [paginationPageSize, setPaginationPageSize] = useState(15);
  const [patientVisit, setPatientVisit] = useState([]);
  const [showPatientVisitModal, setshowPatientVisitModal] = useState(false);
  const [showPatientRevisitModal, setshowPatientRevisitModal] = useState(false);
  const [selectPatientData, setselectPatientData] = useState();
  const [cancelAppointmentDetails, setCancelAppointmentDetails] = useState([]);
  const [showDoctor, setShowDoctor] = useState();
  const [patientDetail, setPatientDetail] = useState({
    patientId: "",
    visitId: "",
    closecomment: "",
    closeScheduledTime: "",
    revisitdate: "",
  });
  const [status, setStatus] = useState(undefined);
  const [toCancelSlot, setToCancelSlot] = useState({});
  const [cancelAppt, setCancelAppt] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [tokenNumber, setTokenNumber] = useState();
  const [selectedPatientRowData, setSelectedPatientRowData] = useState();
  const [selectedPatientSummary, setSummary] = useState();
  const [showPatientSection, setShowPatientSection] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState("OutPatient");
  const [revisitDetail, setRevisitDetail] = useState({
    patientId: "",
    visitId: "",
    closecomment: "",
    closeScheduledTime: "",
    scheduleddate: "",
  });
  const [summary, setSummaryData] = useState({
    preparedBy: "",
    approver: "",
    patientId: "",
    visitId: "",
    notes: "",
    groupname: "",
    subgroup: "",
    type: "",
  });
  const [type, setType] = useState("All");
  const [typeList, setTypeList] = useState([]);
  const [typeListCopy, setTypeListCopy] = useState([]);
  const [isVisitListLoading, setIsVisitListLoading] = useState(true);
  const [reloadData, setreloadData] = useState(false);
  const [insurancestatus, setInsuranceStatus] = useState();
  const [billaction, setBillAction] = useState();
  const [closebtnAcion, setCloseBtnAction] = useState();
  const [onmodal, setOnModal] = useState(false);
  const [onBoardmodal, setOnBoardModal] = useState(false);
  const [selectedType, setSelecetdType] = useState();
  const [visitList, setVisitList] = useState();
  const [countAll, setCountAll] = useState();
  const [countIn, setCountIn] = useState();
  const [countOut, setCountOut] = useState();
  const [countWalkin, setCountWalkin] = useState();
  const [countOnline, setCountOnline] = useState();
  const [IpLists, setIpLists] = useState(false);
  const [roomDealocateModal, setRoomDealocateModal] = useState(false);
  const [pdf, setPdf] = useState();
  const dispatch = useDispatch();
  const [showDependent, setShowDependent] = useState(false);
  const todayDate = format(new Date(), "yyyy-MM-dd");
  // const [searchText, setSerchText] = useState();
  const isHandlingPageChangeRef = useRef(false);
  const currentTime = format(new Date(), "HH:mm");
  const [selecteddate, setSelecteddate] = useState(todayDate);
  const defaultDate = format(
    new Date().setDate(new Date().getDate() + 7),
    "yyyy-MM-dd",
  );
  const [selectedTime, setSelectedTime] = useState(currentTime);
  const [dischargeDate, setDischargeDate] = useState();
  const [dischargeTime, setDischargeTime] = useState();
  const [dischargeDateSelect, setDischargeDateSelect] = useState();
  const [dependentsCount, setDependentsCount] = useState(0);
  const [movetobill, setMoveToBill] = useState(false);
  const [dependentMname, setDependentMname] = useState("");
  const [doctorList, setdoctorList] = useState({ doctors: "" });
  const [patientCloseModal, setPatientCloseModal] = useState(false);
  const [patientForceCloseModal, setPatientForceCloseModal] = useState(false);
  const [forceCloseReason, setForceCloseReason] = useState("");
  const [forceCloseComment, setForceCloseComment] = useState("");
  const forceCloseReasons = [
    "Higher Center Treatment",
    "Other",
  ];

  const [errorList, setErrorList] = useState([]);
  const currentPageRef = useRef(null);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const gridRef = useRef(null);
  const isPaginatingRef = useRef(false);
  const lastRequestedPageRef = useRef(null);
  const [pagenumber, setPagenumber] = useState(0);
  const isUserTriggeredRef = useRef(false);
  const [pagenenationReslist, setPagenenationReslist] = useState([]);
  const isMountedRef = useRef(true);
  const { searchText, dateRange, searchListResult, tags, pageReload } = props;

  // extractFilters reads from tags object state
  const extractFilters = (tagList = tags) => {
    const textTag = tagList.find((t) => t.type === "text");
    const dateTag = tagList.find((t) => t.type === "date");

    return {
      searchString: textTag ? textTag.value : "",
      dateFrom: dateTag ? dateTag.from : "",
      dateTo: dateTag ? dateTag.to : "",
    };
  };
  const { searchString, dateFrom, dateTo } = props?.tags
    ? extractFilters()
    : {};
  // === COMPARATORS & FORMATTING HELPERS ===
  const customComparator = (valueA, valueB) => {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
  };

  const getFormattedDate = (date) => {
    const reqdate = new Date(date);
    return format(reqdate, "MMM dd yyyy");
  };

  const monthToNum = (visitDate) => {
    if (!visitDate || visitDate.length !== 10) return null;
    const yearNumber = parseInt(visitDate.substring(6, 10), 10);
    const monthNumber = parseInt(visitDate.substring(3, 5), 10);
    const dayNumber = parseInt(visitDate.substring(0, 2), 10);
    return yearNumber * 10000 + monthNumber * 100 + dayNumber;
  };

  const dateComparator = (date1, date2, nodeA, nodeB) => {
    const date1Number = monthToNum(date1);
    const date2Number = monthToNum(date2);
    if (date1Number === null && date2Number === null) return 0;
    if (date1Number === null) return -1;
    if (date2Number === null) return 1;
    if (date1Number !== date2Number) return date1Number - date2Number;

    // Visits created on the same day must still have a deterministic order.
    // A larger visit id is the newer record when timestamps have equal dates.
    return (Number(nodeA?.data?.visit?.id) || 0) -
      (Number(nodeB?.data?.visit?.id) || 0);
  };

  const getDisplayedVisitTime = (item) => {
    const visit = item?.visit;
    const rawDate = visit?.apptdate || visit?.visitDate;
    if (!rawDate) return 0;

    const displayedDate = new Date(rawDate);
    if (Number.isNaN(displayedDate.getTime())) return 0;

    // The grid displays appointment time when it is available. Apply that
    // time to the displayed date so the default order matches the column.
    if (visit?.apptdate && Number(visit?.appthours) > 0) {
      displayedDate.setHours(
        Number(visit.appthours),
        Number(visit.apptminutes) || 0,
        0,
        0,
      );
    }

    return displayedDate.getTime();
  };

  const sortByDisplayedVisitDate = (list = []) =>
    [...list].sort((a, b) => {
      return (
        getDisplayedVisitTime(b) - getDisplayedVisitTime(a) ||
        (Number(b?.visit?.id) || 0) - (Number(a?.visit?.id) || 0) ||
        (Number(b?.id) || 0) - (Number(a?.id) || 0)
      );
    });

  const getFormatedReqtDate = (date) => {
    return format(new Date(date), "MMM dd yyyy");
  };

  const getFormatedApptDate = (date) => {
    return format(new Date(date), "MMM dd yyyy");
  };
const formatTime12hr = (hours, minutes) => {
  const h = Number(hours);
  const m = Number(minutes);
  if (isNaN(h) || isNaN(m)) return "";
  const period = h >= 12 ? "PM" : "AM";
  let hour12 = h % 12;
  if (hour12 === 0) hour12 = 12; // 0 and 12 both display as 12
  const mm = String(m).padStart(2, "0");
  return `${hour12}:${mm} ${period}`;
};
  // === COLUMN DEFINITIONS ===
  const [columnDefs] = useState([
    {
      headerName: "MAIN",
      field: "maIn",
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "maIn",
      minWidth: 120,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return <span>-</span>;
        return <span style={{ fontWeight: 700, color: '#0f172a' }}>{row.maIn}</span>;
      },
    },
    {
      headerName: "IP/OP No",
      field: "ipOpNo",
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "ipOpNo",
      minWidth: 130,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return (
          <div style={{ lineHeight: '1.4', padding: '4px 0' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.ipOpNo || '-'}</div>
            {(row.visit?.visitflag || "").toLowerCase() !== "walkin" && (
              <div style={{ fontSize: 12, color: '#64748b' }}>{row.visit?.type || '-'}</div>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Name",
      field: "name",
      cellClass: ["ag-cell-center", "table-head"],
      headerClass: "ag-header-left",
      headerTooltip: "name",
      tooltipField: "name",
      minWidth: 220,
      flex: 2,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        const fullName = row.name || [row.fname, row.mname, row.lname].filter(Boolean).join(' ') || 'Patient';
        const initial = (fullName || 'P').charAt(0).toUpperCase();
        const phone = row.phno || row.phone || row.phoneno || '';
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
            <div className="avatar-sm" style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'linear-gradient(135deg, #2563eb, #3b82f6)',
              color: 'white', fontWeight: 700,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 15, flexShrink: 0,
            }}>
              {initial}
            </div>
            <div style={{ lineHeight: '1.4', minWidth: 0 }}>
              <div style={{ fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{fullName}</div>
              {phone && <div style={{ fontSize: 12, color: '#64748b' }}>{phone}</div>}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Doctor",
      field: "doc",
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "doctor",
      minWidth: 220,
      flex: 1.5,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.doc || ''}</div>
            {row.docDept && <div style={{ fontSize: 12, color: '#64748b' }}>{row.docDept}</div>}
          </div>
        );
      },
    },
    {
      headerName: "Counselor",
      field: "Counsellor",
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "Counsellor",
      minWidth: 160,
      flex: 1,
      hide:
        !org?.isCounsellor?.display ||
        org?.orgCode === ORG_CODES.VEDAMAAYU,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return <span style={{ fontWeight: 700, color: '#0f172a' }}>{row.Counsellor || ''}</span>;
      },
    },
    {
      headerName: "Category",
      field: "category",
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "category",
      minWidth: 120,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return <span style={{ fontWeight: 700, color: '#0f172a' }}>{row.category || '-'}</span>;
      },
    },
    {
      headerName: "Visit/Appointment Time",
      headerTooltip: "Visit/Appointment Time",
      field: "visitDate",
valueGetter: (params) => {
  const visit = params.data?.visit;
  if (!visit) return "";
  const rawDate = visit.apptdate || visit.visitDate; // raw ISO strings, not formatted
  if (!rawDate) return "";

  const d = new Date(rawDate);
  if (isNaN(d.getTime())) return "";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
},
      comparator: dateComparator,
      filter: "agTextColumnFilter",
      cellClass: ["ag-cell-center"],
      minWidth: 180,
      flex: 1.2,
      cellRendererFramework: (params) => {
        if (!params.value) return <span style={{ color: '#94a3b8' }}>-</span>;
        const [day, month, year] = params.value.split("/");
        const d = new Date(`${year}-${month}-${day}`);
        const displayDate = d.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{displayDate}</div>
            {params.data.appTime && (
              <div style={{ fontSize: 12, color: '#64748b' }}>
                Time: {params.data.appTime}
              </div>
            )}
          </div>
        );
      },
      headerClass: "ag-header-left",
    },
    {
      headerName: "Status",
      field: "status",
      onGridReady: "open",
      minWidth: 110,
      flex: 0.6,
      cellClass: ["ag-cell-center"],
      headerTooltip: "Status",
      headerClass: "ag-header-left",
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return <Badge variant={statusVariant(row.status || 'open')}>{row.status || 'open'}</Badge>;
      },
    },
    {
      headerName: "Insurance",
      field: "insurancePlanName",
      cellClass: ["ag-cell-center"],
      headerTooltip: "Insurance",
      headerClass: "ag-header-left",
      tooltipField: "insurancePlanName",
      minWidth: 130,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return <span style={{ fontWeight: 500, color: '#0f172a' }}>{row.insurancePlanName || '-'}</span>;
      },
    },
    {
      headerName: "Room",
      field: "roomName",
      minWidth: 180,
      flex: 1,
      cellClass: ["ag-cell-center"],
      headerTooltip: "Room",
      headerClass: "ag-header-left",
      valueGetter: (params) => {
        if (Array.isArray(params?.data?.roomList)) {
          return params.data.roomList
            .map(r => {
              if (!r?.roomName) return "";
              return `${r?.floorId ? `${r.floorId}, ` : ""}${r.roomName}`;
            })
            .filter(Boolean)
            .join(", ");
        }
        const room = params?.data?.room;
        if (!room?.roomName) return null;
        return `${room?.floorId ? `${room.floorId}, ` : ""}${room.roomName}`;
      },
      cellRendererFramework: (params) => {
        const value = params.value;
        if (!value) return <span style={{ color: '#94a3b8' }}>-</span>;
        const displayValue = value.length > 25 ? value.substring(0, 25) + '...' : value;
        return (
          <div style={{ 
            padding: '4px 0', 
            lineHeight: '1.4',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            <span style={{ fontWeight: 700, color: '#0f172a' }}>{displayValue}</span>
          </div>
        );
      },
    },
//   {
//   headerName: "Room",
//   field: "roomName",
//   flex: 2.8,
//   cellClass: ["ag-cell-center", "wrap-cell"],
//   headerTooltip: "Room",
//   headerClass: "ag-header-left",
//   wrapText: true,       // ✅ Add this
//   autoHeight: true,     // ✅ Add this
//   valueGetter: (params) => {
//     if (Array.isArray(params?.data?.roomList)) {
//       return params.data.roomList
//         .map((r) => `${r.floorId != null ? `${r.floorId}, ` : ""}${r.roomName}`)
//         .join("\n");
//     }
//     const room = params?.data?.room;
//     if (!room?.roomName) return null;
//     return `${room.floorId != null ? `${room.floorId}, ` : ""}${room.roomName}`;
//   },
// },


    {
      headerName: "Actions",
      field: "Actions",
      cellRenderer: "BtnCellRenderer",
      cellStyle: { textAlign: "center" },
      cellClass: ["ag-cell-center"],
      headerTooltip: "Actions",
      headerClass: "ag-header-left",
      sortable: false,
      filter: false,
      floatingFilter: false,
      minWidth: 200,
      flex: 1.2,
    },
  ]);

  const [OpcoulmnDefs] = useState([
    {
      headerName: "MAIN",
      field: "maIn",
      cellClass: ["ag-cell-center"],
      headerTooltip: "maIn",
      headerClass: "ag-header-left",
      minWidth: 120,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return <span>-</span>;
        return <span style={{ fontWeight: 700, color: '#0f172a' }}>{row.maIn}</span>;
      },
    },
    {
      headerName: "IP/OP No",
      field: "ipOpNo",
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "ipOpNo",
      minWidth: 130,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return (
          <div style={{ lineHeight: '1.4', padding: '4px 0' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.ipOpNo || '-'}</div>
            {(row.visit?.visitflag || "").toLowerCase() !== "walkin" && (
              <div style={{ fontSize: 12, color: '#64748b' }}>{row.visit?.type || '-'}</div>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Name",
      field: "name",
      cellClass: ["ag-cell-center", "table-head"],
      headerTooltip: "name",
      headerClass: "ag-header-left",
      minWidth: 220,
      flex: 2,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        const fullName = row.name || [row.fname, row.mname, row.lname].filter(Boolean).join(' ') || 'Patient';
        const initial = (fullName || 'P').charAt(0).toUpperCase();
        const phone = row.phno || row.phone || row.phoneno || '';
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' }}>
            <div className="avatar-sm" style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'linear-gradient(135deg, #2563eb, #3b82f6)',
              color: 'white', fontWeight: 700,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 15, flexShrink: 0,
            }}>
              {initial}
            </div>
            <div style={{ lineHeight: '1.4', minWidth: 0 }}>
              <div style={{ fontWeight: 600, color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{fullName}</div>
              {phone && <div style={{ fontSize: 12, color: '#64748b' }}>{phone}</div>}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Doctor",
      field: "doc",
      cellClass: ["ag-cell-center"],
      headerTooltip: "doctor",
      headerClass: "ag-header-left",
      minWidth: 220,
      flex: 1.5,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{row.doc || ''}</div>
            {row.docDept && <div style={{ fontSize: 12, color: '#64748b' }}>{row.docDept}</div>}
          </div>
        );
      },
    },
    {
      headerName: "Counselor",
      field: "Counsellor",
      cellClass: ["ag-cell-center"],
      headerTooltip: "Counsellor",
      hide:
        !org?.isCounsellor?.display ||
        org?.orgCode === ORG_CODES.VEDAMAAYU,
      headerClass: "ag-header-left",
      minWidth: 160,
      flex: 1,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return <span style={{ fontWeight: 700, color: '#0f172a' }}>{row.Counsellor || ''}</span>;
      },
    },
    {
      headerName: "Category",
      field: "category",
      cellClass: ["ag-cell-center"],
      headerTooltip: "category",
      headerClass: "ag-header-left",
      minWidth: 120,
      flex: 0.8,
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return <span style={{ fontWeight: 700, color: '#0f172a' }}>{row.category || '-'}</span>;
      },
    },
    {
      headerName: "Visit/Appointment Time",
      headerTooltip: "Visit/Appointment Time",
      field: "visitDate",
     valueGetter: (params) => {
  const visit = params.data?.visit;
  if (!visit) return "";
  const rawDate = visit.apptdate || visit.visitDate;
  if (!rawDate) return "";
  const d = new Date(rawDate);
  if (isNaN(d.getTime())) return "";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
},
      comparator: dateComparator,
      filter: "agTextColumnFilter",
      cellClass: ["ag-cell-center"],
      minWidth: 180,
      flex: 1.2,
      cellRendererFramework: (params) => {
        if (!params.value) return <span style={{ color: '#94a3b8' }}>-</span>;
        const [day, month, year] = params.value.split("/");
        const d = new Date(`${year}-${month}-${day}`);
        const displayDate = d.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
        return (
          <div style={{ padding: '4px 0', lineHeight: '1.4' }}>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{displayDate}</div>
            {params.data.appTime && (
              <div style={{ fontSize: 12, color: '#64748b' }}>
                Time: {params.data.appTime}
              </div>
            )}
          </div>
        );
      },
      headerClass: "ag-header-left",
    },
    {
      headerName: "Status",
      field: "status",
      onGridReady: "open",
      minWidth: 110,
      flex: 0.6,
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "Status",
      cellRendererFramework: (params) => {
        const row = params.data;
        if (!row) return null;
        return <Badge variant={statusVariant(row.status || 'open')}>{row.status || 'open'}</Badge>;
      },
    },
    {
      headerName: "Actions",
      field: "Actions",
      cellRenderer: "BtnCellRenderer",
      cellStyle: { textAlign: "center" },
      cellClass: ["ag-cell-center"],
      headerClass: "ag-header-left",
      headerTooltip: "Actions",
      sortable: false,
      filter: false,
      floatingFilter: false,
      minWidth: 200,
      flex: 1.2,
    },
  ]);

  const defaultColDef = useMemo(
    () => ({
      editable: true,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
      floatingFilter: true,
    }),
    [],
  );

  const [AddPatientmodel, setaddPatientModel] = useState(false);
  const patientsList = useSelector(
    (state) => state.patientDetailsState.patientsList,
  );
  const page = useSelector((state) => state.patientDetailsState.page);

  // === MODAL HANDLERS ===
  const patientVisitClick = () => setshowPatientVisitModal(true);
  const patientCloseClick = () => setshowPatientRevisitModal(true);
  const Addpatient = () => setaddPatientModel(true);

  const closeModal = (event) => {
    setshowPatientVisitModal(false);
    setshowPatientRevisitModal(false);
    setaddPatientModel(false);
    let ServerResVal = event;
    if (event?.successMessages) ServerResVal.success = event.successMessages[0];
    if (event?.errorMessages) ServerResVal.error = event.errorMessages[0];
    setServerRes({ ...ServerResVal });
    setTimeout(closeAlert, 3000);
  };

  // === ACTION RENDERER ===
  const handleRendererCall = (props) => {
    setselectPatientData(props.visitsList);
    dispatch(patientActions.setPatientDetails(props.visitsList));

    const isWalkinVisit =
      (props.visitsList?.visit?.visitflag || "").toLowerCase() === "walkin";
    if (
      isWalkinVisit &&
      ["dischargeSummary", "AllocateRoom"].includes(props.visitsList.typeFlag)
    ) {
      return;
    }

    switch (props.visitsList.typeFlag) {
      case "assignDoctor":
        //   history.push({
        //   pathname: `/PatientSections/${props.visitsList.id}/${props.visitsList.visit.id}`,
        // });
        

        history.push({
          pathname: "/booking/new-session",
          state: {
            selectedPatient: props.visitsList,
            from: "patientList",
            existingVisitId: props.visitsList.visit?.id || props.visitsList.visitId,
          },
        });

        break;

      case "patientClose":
        if (props?.visitsList?.visit?.internalStatus === "notInSite") {
          props.visitsList.cancelExistingAppt = true;
          cancelAppointment(timeSlots, props.visitsList);
        } else {
          const check = "revisit";
          // if (org?.id === "2") {
          setVisitList(props.visitsList);
          validatePatientStatus(props.visitsList);
          getrevisitbyId(props.visitsList);
          // } else {
          //   validatePatientStatus(props.visitsList);
          //   getrevisitbyId(props.visitsList);
          // }
        }
        break;

      case "patientOnBoard":
        if (props?.visitsList?.visit?.internalStatus === "notInSite") {
          inSitePatient(props.visitsList);
        } else {
          onBoardModalOpen(props.visitsList);
        }
        break;

      case "dischargeSummary":
        const url = `/DischargeSummary/${props.visitsList.id}/${props.visitsList.visit.id}`;
        window.open(url, "_blank");
        renderVisitLists();
        break;

      case "Complaint":
      case "Insurance":
      case "AttachFile":
      case "AllocateRoom":
        history.push({
          pathname: `/PatientSections/${props.visitsList.id}/${props.visitsList.visit.id}`,
        });
        break;

      case "MoveToBill":
        // if (org?.id === "2") {
        history.push({
          pathname: `/billing/${props.visitsList.id}/${props.visitsList.visitId}`,
        });
        // } else {
        //   ModalOpen(props.visitsList);
        // }
        break;

      case "ProcedureList":
        window.open(
          `/procedure-list/${props.visitsList.id}/${props.visitsList.visit.id}`,
          "_blank",
          "noopener,noreferrer",
        );
        break;

      default:
        patientVisitClick(props.visitsList);
        break;
    }
  };

  // === API CALLS & BUSINESS LOGIC ===
  const getrevisitbyId = (props, check) => {
    const patientId = props.id;
    const visitId = props?.visit?.id;
    dispatch(
      patientActions.getrevisitbyId(patientId, visitId, (resCb) => {
        if (resCb) {
          revisitDetail.scheduleddate = resCb.scheduleddate;
          revisitDetail.patientId = resCb.patientId;
          revisitDetail.visitId = resCb.visitId;
          revisitDetail.closecomment = resCb.comment;
          // if (check === "revisit") patientCloseClick(props.visitsList);
        }
      }),
    );
  };

  const inSitePatient = (params) => {
    let doctor;
    const visitDate = format(new Date(), "yyyy-MM-dd HH:mm:ss");
    const dateTimeString = `${visitDate}`;
    if (params.visit.internalStatus === "notInSite") {
      dispatch(
        patientActions.UpdateToInSitePatient(
          params.visit.id,
          dateTimeString,
          (resCb) => {
            if (resCb?.successMessages) {
              const state = resCb.paymentStatus;
              if (params.visitAssignmentList.length > 0) {
                for (const assignVisit of params.visitAssignmentList) {
                  if (
                    assignVisit.type.toLowerCase() === "doctor" &&
                    assignVisit.targetid !== 0 &&
                    assignVisit.status === "open"
                  ) {
                    doctor = assignVisit.targetid;
                    break;
                  }
                }
              }

              if (doctor) {
                dispatch(
                  patientActions.getPatientProcedureInfo(
                    params.id,
                    params.visit.id,
                    "showAllVisits",
                    (resCb) => {
                      if (resCb) {
                        setTokenNumber(resCb.patientresp.tokenNumber);
                        tokenChange(params.visit.id, doctor, "doctor", params);
                      }
                    },
                  ),
                );
              }

              const lastVisit = sixMonthsPrior(params.lastRegisteredOn);
              //before here we are using teh org id 1.cahnegd to org codeee
              if (state === "Payment" && org?.orgCode === ORG_CODES.MANASWINI) {
                history.push({
                  pathname: `/Payment/${params.fname}/${params.id}/${params.visit.id}/${params.erpCustId}`,
                });
              } else {
                history.push({
                  pathname: `/PatientSections/${params.id}/${params.visit.id}`,
                });
              }
            }
          },
        ),
      );
    }
  };

  const sixMonthsPrior = (date) => {
    const d = new Date(date);
    const t = new Date();
    const diffYears = t.getFullYear() - d.getFullYear();
    const diffMonths = t.getMonth() - d.getMonth();
    return diffYears * 12 + diffMonths >= 6;
  };

  const tokenChange = (visitId, gvId, typeaa, params) => {
    if (
      params?.visit?.type === "OutPatient" &&
      params?.visit?.status === "open" &&
      typeaa.toLowerCase() === "doctor"
    ) {
      if (parseInt(tokenNumber, 10) > 0) {
        dispatch(tokenActions.recorrectToken(visitId, gvId, (resCb) => { }));
      } else {
        dispatch(tokenActions.tokenGenerate(visitId, gvId, (resCb) => { }));
      }
    }
  };

  const onboardPatient = async () => {
    let ServerResVal = { ...ServerRes };
    let visitListDetails = { ...visitList };
    let type = "";

    if (selectedRadio === "Proxy") {
      type = "OutPatient";
      visitListDetails.visitflag = "Proxy";
    } else if (selectedRadio === "Walkin") {
      type = "InPatient";
      visitListDetails.visitflag = "Walkin";
    } else {
      type = selectedRadio;
      visitListDetails.visitflag = null;
    }

    const matchedGroup = customerGroup.find(
      (group) => group.custGroupId === visitListDetails.custGroupId,
    );
    visitListDetails.custGrpDesc = matchedGroup?.description || "";
    visitListDetails.onboardStatus = "reVisitPatient";
    visitListDetails.appointmentFlag = false;

    let admissionDateTime = "";
    if (type === "InPatient") {
      admissionDateTime = `${selecteddate} ${selectedTime}:00`;
    }

    try {
      const patientId = visitListDetails.id || visitListDetails.patientId;
      let bookingPlanResponse;

      // Ask specifically for today's boardable plan before onboarding. This
      // prevents the generic patient lookup from selecting tomorrow's or a later
      // Scheduled session when the patient is being boarded today.
      try {
        bookingPlanResponse = await bookingplanService.getBookingPlanByPatientId(
          patientId,
          false,
          null,
          true,
        );
      } catch (error) {
        // A missing booking plan is expected for patients using the legacy flow.
        bookingPlanResponse = null;
      }

      const bookingPlan = Array.isArray(bookingPlanResponse?.data)
        ? bookingPlanResponse.data[0]
        : bookingPlanResponse?.data || bookingPlanResponse;
      const bookingPlanId = bookingPlan?.id;

      if (bookingPlanId) {
        const boardResult = await boardPatient(bookingPlanId, {
          type,
          visitFlag: visitListDetails.visitflag,
          admissionDate: type === "InPatient" ? admissionDateTime : "",
        });
        const boardData = boardResult?.data || boardResult;
        const newVisitId =
          boardData?.visit_id || boardData?.visitId || boardData?.visit?.id;
        const newPatientId =
          boardData?.patient_id || boardData?.patientId || patientId;

        if (!newVisitId || !newPatientId) {
          throw new Error("Booking plan boarding response is missing visit data");
        }

        ServerResVal.success = "Patient onboarded successfully";
        setServerRes({ ...ServerResVal });
        setTimeout(closeAlert, 3000);
        setOnBoardModal(false);
        renderVisitLists();

        setTimeout(() => {
          history.push({
            pathname: `/PatientSections/${newPatientId}/${newVisitId}`,
            state: { refreshRoom: Date.now() },
          });
        }, 1500);
        return;
      }

      dispatch(
        patientActions.onboardPatient(
          visitListDetails,
          type,
          admissionDateTime,
          (resCb) => {
            if (resCb) {
              if (resCb.successMessages) {
                const patientresp = resCb.patientresp || resCb;
                const visitId =
                  patientresp.visit?.id || resCb.visit?.id || resCb.visitId;
                const onboardedPatientId =
                  patientresp.id || patientresp.patientId || resCb.patientId;
                const name = patientresp.fname || patientresp.first_name;
                const visitStatus =
                  patientresp.visit?.status || resCb.visit?.status;
                const erpCustId = patientresp.erpCustId || resCb.erpCustId;

                if (!visitId || !onboardedPatientId) {
                  ServerResVal.error =
                    "Patient onboarded but navigation data is missing. Please refresh.";
                  setServerRes({ ...ServerResVal });
                  setTimeout(closeAlert, 3000);
                  setOnBoardModal(false);
                  renderVisitLists();
                  return;
                }

                ServerResVal.success = "Patient onboarded successfully";
                setServerRes({ ...ServerResVal });
                setTimeout(closeAlert, 3000);

                setTimeout(() => {
                  if (visitStatus === "open") {
                    history.push({
                      pathname: `/PatientSections/${onboardedPatientId}/${visitId}`,
                      state: { refreshRoom: Date.now() },
                    });
                  } else if (org?.orgCode === ORG_CODES.MANASWINI) {
                    history.push({
                      pathname: `/Payment/${name}/${onboardedPatientId}/${visitId}/${erpCustId}`,
                    });
                  } else {
                    dispatch(
                      patientActions.registrationFees(
                        erpCustId,
                        0,
                        visitId,
                        onboardedPatientId,
                        org?.orgCode,
                        [],
                        (resCbFees) => {
                          if (resCbFees?.successMessages) {
                            history.push({
                              pathname: `/PatientSections/${onboardedPatientId}/${visitId}`,
                              state: { refreshRoom: Date.now() },
                            });
                          }
                        },
                      ),
                    );
                  }
                }, 2000);
              } else {
                ServerResVal.error =
                  resCb.errorMessages?.[0] || "Patient onboard failed";
                setServerRes({ ...ServerResVal });
                setTimeout(closeAlert, 3000);
              }
              setOnBoardModal(false);
              renderVisitLists();
            }
          },
        ),
      );
    } catch (error) {
      ServerResVal.error = "Onboarding failed. Please try again.";
      setServerRes({ ...ServerResVal });
      setTimeout(closeAlert, 3000);
      setOnBoardModal(false);
      renderVisitLists();
    }
  };

  const doctorlist = (data) => {
    dispatch(
      doctorActions.getDoctorsBasednId(data, (resCb) => {
        if (resCb) {
          setdoctorList({ ...resCb });
        }
      }),
    );
  };

  const getAggriddata = (e) => {
    if (e.colDef.field === "Actions") return;
    dispatch(patientActions.setPatientDetails(e.data));
    e.data.typeFlag = "all";
    setSelectedPatientRowData(e.data);
    sessionStorage.setItem("patientId", JSON.stringify(e.data.id));
    setTimeout(() => setShowPatientSection(true), 500);
    history.push({
      pathname: `/PatientSections/${e.data.id}/${e.data.visit.id}`,
    });
  };

  const categoryFilter = (type) => {
    // props.parentCallBack();
    setType(type);
    const filtered =
      type === "All"
        ? typeListCopy
        : typeListCopy.filter((v) =>
            type === "Walkin"
              ? (v.visit.visitflag || "").toLowerCase() === "walkin"
              : v.visit.type === type &&
                (type !== "InPatient" ||
                  (v.visit.visitflag || "").toLowerCase() !== "walkin"),
          );
    setTypeList(filtered);
    setIsVisitListLoading(false);
    setreloadData((prev) => !prev);
    setIpLists(type === "InPatient");
  };

  const getInsurancestatus = (visitIdList) => {
    if (!isMountedRef.current) return;
    dispatch(
      patientActions.getInsuranceStatus(visitIdList, (resCb) => {
        if (isMountedRef.current && resCb) {
          setInsuranceStatus(resCb.insurancestatus);
        }
      }),
    );
  };

  const getActionsList = (visitIdList) => {
    if (!isMountedRef.current) return;
    dispatch(
      patientActions.getActionList(visitIdList, (resCb) => {
        if (isMountedRef.current && resCb) {
          setBillAction(resCb.actionList);
          setCloseBtnAction(resCb.closeButtonActionList);
        }
      }),
    );
  };

  const ModalOpen = (visitList) => {
    try {
      setAadharValue(visitList?.adhar || "");
      setAadharError("");

      if (visitList?.visit?.dischargeDate) {
        const parts = visitList.visit.dischargeDate.split("T");
        const timePart = parts[1].split(".")[0];
        const [h, m] = timePart.split(":");
        setDischargeDate(parts[0]);
        if (parts[0]) setDischargeDateSelect(true);
        setDischargeTime(`${h}:${m}`);
      }

      setVisitList(visitList);
      setOnModal(true);
    } catch (error) {
      console.error("Failed to prepare move-to-bill modal:", error);
    }
  };

  const checkFordependent = (visitList) => {
    return new Promise((resolve, reject) => {
      dispatch(
        patientActions.dependentCheck(
          visitList.id,
          visitList.visitId,
          (resCb) => {
            if (resCb) {
              if (Array.isArray(resCb)) {
                const dependentList = resCb.map((dep) => ({
                  dependentId: dep.dpid,
                  dependentVisitId: dep.dvid,
                }));
                setDependentsCount(dependentList.length);
                setDependentMname(visitList.fname);

                const isClosed = [
                  "MOVED_TO_BILLING",
                  "INVOICE_GENERATED",
                  "BILL_CLEARED",
                ].includes(visitList.visit.internalStatus);

                resolve(dependentList.length > 0 && !isClosed);
              } else {
                resolve(false);
              }
            } else {
              reject("No response from API");
            }
          },
        ),
      );
      setVisitList(visitList);
    });
  };

  const KeepDependents = () => {
    const ServerResVal = { ...ServerRes };
    const ptid = visitList.id;
    const vid = visitList.visitId;
    const now = new Date();
    const distdate = encodeURIComponent(
      now.toISOString().slice(0, 19).replace("T", " "),
    );

    dispatch(
      patientActions.KeepDependents(ptid, vid, distdate, (resCb) => {
        if (resCb) {
          if (resCb.errorMessages) {
            ServerResVal.error = Array.isArray(resCb.errorMessages)
              ? resCb.errorMessages.join("; ")
              : resCb.errorMessages;
          } else if (resCb.successMessages) {
            ServerResVal.success =
              "Successfully moved to billing and room assigned to dependent";
          }

          setServerRes({ ...ServerResVal });
          setTimeout(closeAlert, 3000);
          toggle();
          renderVisitLists();
        }
      }),
    );
    setShowDependent(false);
  };

  const onBoardModalOpen = (visitList) => {
    setVisitList(visitList);
    setOnBoardModal(true);
  };

  const toggle = () => {
    setOnModal(false);
    setOnBoardModal(false);
    setRoomDealocateModal(false);
    setDischargeDate("");
    setDischargeTime("");
    setShowDependent(false);
    setPatientCloseModal(false);
    setPatientForceCloseModal(false);
  };

  const updatePatientAadhar = (selectedPatient) => {
    if (
      org?.isAadharNumberMandatory?.forInpatients &&
      (!visitList?.adhar || visitList?.adhar === "")
    ) {
      if (!aadharValue) {
        setAadharError("Please Enter Aadhaar Number");
        return false;
      }
      if (aadharValue.length !== 12 || isNaN(aadharValue)) {
        setAadharError("Please Enter Valid Aadhaar Number");
        return false;
      }

      const parsedDate = parseISO(selectedPatient.visit.admsnDate);
      const admissionDateTime = `${format(parsedDate, "yyyy-MM-dd")} ${format(
        parsedDate,
        "HH:mm",
      )}:00`;

      dispatch(
        patientActions.updatePatient(
          selectPatientData,
          "",
          admissionDateTime,
          (resCb) => {
            if (resCb) {
              const ServerResVal = { ...ServerRes };
              ServerResVal[resCb.state === "success" ? "success" : "error"] =
                resCb.message || resCb.messages?.message;
              setServerRes(ServerResVal);
            }
          },
        ),
      );
      return true;
    }
    return true;
  };

  const MoveToBilling = () => {
    if (!updatePatientAadhar(selectPatientData)) return;

    const ServerResVal = { ...ServerRes };
    const data = {
      patientId: visitList.visit.patientId,
      visitId: visitList.visit.id,
    };

    let dischargeDateTime = "";
    if (dischargeDate && dischargeDateSelect) {
      dischargeDateTime = `${dischargeDate} ${dischargeTime}:00`;
    } else {
      dischargeDateTime = `${selecteddate} ${selectedTime}:00`;
    }
    data.dischargeDate = dischargeDateTime;

    dispatch(
      patientActions.moveToBilling(data, (resCb) => {
        if (resCb) {
          if (resCb.errorMessages) {
            ServerResVal.error = resCb.errorMessages;
            if (resCb.count === 2)
              setTimeout(() => setRoomDealocateModal(true), 3000);
            if (resCb.count === 4)
              setTimeout(
                () =>
                  checkFordependent(visitList).then((hasDep) => {
                    if (hasDep) setShowDependent(true);
                  }),
                3000,
              );
          } else if (resCb.successMessages) {
            ServerResVal.success = Array.isArray(resCb.successMessages)
              ? resCb.successMessages.join("; ")
              : resCb.successMessages;
          }

          setServerRes({ ...ServerResVal });
          setTimeout(closeAlert, 3000);
          toggle();
          renderVisitLists();
        }
      }),
    );
  };

  const validatePatientStatus = (patient) => {
    const ServerResVal = { ...ServerRes };
    dispatch(
      patientActions.validatePatientStatus(
        patient.id,
        patient.visit.id,
        patient.erpCustId,
        (resCb) => {
          if (!resCb) return;
          console.log("validatePatientStatus response:", resCb);

          if (resCb.errorMessages) {
            const billingPendingMsg = VALIDATE_STRING_FORCLOSE;

            const errorArray = Array.isArray(resCb.errorMessages)
              ? resCb.errorMessages
              : [resCb.errorMessages];

            const isOnlyBillingPending =
              errorArray.length === 1 && errorArray[0] === billingPendingMsg;

            if (
              (org?.orgCode === ORG_CODES.MANASWINI || org?.orgCode === ORG_CODES.VEDAMAAYU) &&
              patient?.visit?.type?.toLowerCase() === "inpatient" &&
              patient?.visit?.internalStatus?.toLowerCase() !== "forceclose" &&
              isOnlyBillingPending
            ) {
              setErrorList(errorArray);
              setPatientForceCloseModal(true);
            } else {
              ServerResVal.error = errorArray.join(" ");
              setServerRes(ServerResVal);
              setTimeout(closeAlert, 5000);
            }
          } else if (resCb.successMessages) {
            if (patient?.visit?.type === "InPatient") {
              setPatientCloseModal(true);
            } else {
              patientCloseClick();
            }
          }
        },
      ),
    );
  };
  // const patientForceCloseSave = () => {
  //   const data = {
  //     ...patientDetail,
  //     patientId: visitList.id,
  //     visitId: visitList.visitId,
  //     closescheduleddate: revisitDetail.scheduleddate,
  //     closecomment: "forceclose",
  //     forceCloseReason: forceCloseReason,
  //     forceCloseComment: forceCloseComment,
  //   };

  //   dispatch(
  //     patientActions.updateVAStatus(data, (resCb) => {
  //       if (resCb) {
  //         const ServerResVal = { ...ServerRes };
  //         ServerResVal[resCb.successMessages ? "success" : "error"] =
  //           (resCb.successMessages || resCb.errorMessages)?.[0] || "Unknown";
  //         setServerRes(ServerResVal);
  //         setTimeout(closeAlert, 3000);
  //         toggle();
  //         renderVisitLists();
  //       }
  //     }),
  //   );
  // };


const patientForceCloseSave = () => {
  if (visitList?.visit?.type?.toLowerCase() !== "inpatient") {
    setPatientForceCloseModal(false);
    setServerRes({
      ...ServerRes,
      error: "Force close is only available for inpatient visits",
    });
    setTimeout(closeAlert, 5000);
    return;
  }

  if (!forceCloseComment || forceCloseComment.trim() === "") {
    setForceCloseCommentError("Force close comment is required");
    return;
  }

  setForceCloseCommentError("");

  const data = {
    ...patientDetail,
    patientId: visitList.id,
    visitId: visitList.visitId,
    closescheduleddate: revisitDetail.scheduleddate,
    closecomment: "forceclose",
    forceCloseReason: forceCloseReason,
    forceCloseComment: forceCloseComment,
  };

  dispatch(
    patientActions.updateVAStatus(data, (resCb) => {
      if (resCb) {
        const ServerResVal = { ...ServerRes };
        ServerResVal[resCb.successMessages ? "success" : "error"] =
          (resCb.successMessages || resCb.errorMessages)?.[0] || "Unknown";
        setServerRes(ServerResVal);
        setTimeout(closeAlert, 3000);
        toggle();
        renderVisitLists();
      }
    }),
  );
};

  const patientCloseSave = () => {
    const data = {
      ...patientDetail,
      patientId: visitList.id,
      visitId: visitList.visitId,
      closescheduleddate: revisitDetail.scheduleddate,
      closecomment: revisitDetail.closecomment,
    };

    dispatch(
      patientActions.updateVAStatus(data, (resCb) => {
        if (resCb) {
          const ServerResVal = { ...ServerRes };
          ServerResVal[resCb.successMessages ? "success" : "error"] =
            (resCb.successMessages || resCb.errorMessages)?.[0] || "Unknown";
          setServerRes(ServerResVal);
          setTimeout(closeAlert, 3000);
          toggle();
          renderVisitLists();
        }
      }),
    );
  };

  const AlreadyMovedBill = () => {
    setOnModal(false);
    renderVisitLists();
  };

  const cancelPatientClose = () => {
    setPatientCloseModal(false);
    setPatientForceCloseModal(false);
    renderVisitLists();
  };

  const closeDependentModel = () => {
    setShowDependent(false);
    renderVisitLists();
  };

  const roomDealocate = () => {
    const ServerResVal = { ...ServerRes };
    const data = {
      patientId: visitList.visit.patientId,
      visitId: visitList.visit.id,
      dischargeDate:
        dischargeDate && dischargeDateSelect
          ? `${dischargeDate} ${dischargeTime}:00`
          : `${selecteddate} ${selectedTime}:00`,
    };

    dispatch(
      patientActions.roomDealocate(data, (resCb) => {
        if (resCb) {
          ServerResVal[resCb.successMessages ? "success" : "error"] =
            Array.isArray(resCb.successMessages || resCb.errorMessages)
              ? (resCb.successMessages || resCb.errorMessages).join("; ")
              : resCb.successMessages || resCb.errorMessages;
          setServerRes(ServerResVal);
          setTimeout(closeAlert, 3000);
          setRoomDealocateModal(false);
          renderVisitLists();
        }
      }),
    );
  };

  // === RENDER VISIT LIST (Main loader) ===
  const renderVisitLists = () => {
    setIsVisitListLoading(true);
    gridRef.current?.showLoadingOverlay();

    const isDateRangeActive = !!(dateRange?.start || dateRange?.end);

    const normalizeInsuranceDetails = (item) => {
      const insurancePlan = item.insurancePlan || "";
      let insuranceStatus = item.insurance;
      if (typeof insuranceStatus === "string") {
        insuranceStatus = insuranceStatus.trim().toUpperCase();
      }
      item.insurancePlanName =
        insuranceStatus === "YES"
          ? insurancePlan.trim() !== ""
            ? insurancePlan
            : "-"
          : "No";
      return item;
    };

    const processPatientList = (list, isSearchMode = false) => {
      return list
        .map((item) => {
          item = normalizeInsuranceDetails(item);
          item.ipOpNo = item?.visit?.ipopnumber || "-";
          if (isSearchMode) setAggridByRoleSearch(item);
          else setAggridByRole(item);
          buttonActions(item);

          if (helperServices.CheckAccessLevel("FrontDeskPatients")) {
            return item &&
              (!item.person || !item.counsellor) &&
              item.visit.status === "open"
              ? item
              : null;
          }
          return item;
        })
        .filter(Boolean);
    };

    const updateVisitCounts = (list) => {
      setTypeList(list);
      setTypeListCopy(list);
      setIsVisitListLoading(false);
      setType("All");
      setPatientVisit(list);
      setCountIn(
        list.filter(
          (i) =>
            i.visit.type === "InPatient" &&
            (i.visit.visitflag || "").toLowerCase() !== "walkin",
        ).length,
      );
      setCountOut(list.filter((i) => i.visit.type === "OutPatient").length);
      setCountWalkin(
        list.filter(
          (i) => (i.visit.visitflag || "").toLowerCase() === "walkin",
        ).length,
      );
      setCountOnline(
        list.filter((i) => i.visit.type === "OnlinePatient").length,
      );
      setCountAll(list.length);
      // A new search/category result must start from its first valid page.
      gridRef.current?.paginationGoToFirstPage();
    };

    // CASE 1: Default load
    // NEW unified check: search is active only if tags contain filters
    const hasTextTag = tags.some((t) => t.type === "text");
    const hasDateTag = tags.some((t) => t.type === "date");

    const searchActive = hasTextTag || hasDateTag;

    if (!searchActive) {
      dispatch(
        patientActions.ListVisits({}, (resCb) => {
          if (!isMountedRef.current) return;

          dispatch(patientActions.setPageHeader("Admin"));

          const patientVisit = sortByDisplayedVisitDate(
            Array.isArray(resCb?.patsearchreslt) ? resCb.patsearchreslt : [],
          );

          const visitIdList = patientVisit.map((v) => v.visit.id);
          getInsurancestatus(visitIdList);
          getActionsList(visitIdList);

          const processed = processPatientList(patientVisit);
          updateVisitCounts(processed);
        }),
      );
    }
    // CASE 2/3/4: Search or date range
    else {
      const list = sortByDisplayedVisitDate(searchListResult || []);
      const processed = processPatientList(list, true);
      updateVisitCounts(processed);
    }
  };
  // const formatName = (str) =>
  //   str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
  // === AG-GRID DATA MAPPERS ===
  const setAggridByRole = (item) => {
    // item.name = [item.fname, item.mname, item.lname].filter(Boolean).join(" ");;
    item.name = getFullName(item.fname, item.mname, item.lname);
    if (item.visit.reqtdate) {
      item.reqtdt = `${getFormatedReqtDate(item.visit.reqtdate)} ${item.visit.reqthours
        }:${item.visit.reqtminutes}`;
    }
    item.status = item.visit.status;
    if (item.visit.apptdate) {
      item.apptdt = `${getFormatedApptDate(item.visit.apptdate)} ${item.visit.appthours
        }:${item.visit.apptminutes}`;
    }
    item.apptdate = item.visit.apptdate;
    item.appthours = item.visit.appthours;
    item.apptminutes = item.visit.apptminutes;
    item.meetingStatus = item.visit.meetingStatus;
    if (item.person?.first_name)
      item.doc = getFullName(item.person.first_name, "", item.person.last_name);
    if (item.counsellor)
      item.Counsellor = getFullName(
        item.counsellor.first_name,
        "",
        item.counsellor.last_name,
      );
    item.category = item.visit.visitflag || item.visit.type || "--";
    item.visitDate = item.visit.visitDate
      ? getFormattedDate(item.visit.visitDate)
      : "--";
  item.appTime =
  item.visit.appthours > 0
    ? formatTime12hr(item.visit.appthours, item.visit.apptminutes)
    : "";
    item.insurance = item.visit.insurance;
    item.doc = buildDoctorLabel(item);
    item.docDept = extractDoctorDepartment(item);
    item.roomName = buildRoomLabel(item);
    item.room = item.room || null;
    item.fileNo = item.fileNo;
    item.maIn = item.id;
  };

  const setAggridByRoleSearch = (item) => {
    item.fullName = getFullName(item.fname, item.mname, item.lname);
    // item.name = [item.fname, item.mname, item.lname].filter(Boolean).join(" ");
    item.name = item.fullName;
    if (item.visit.reqtime) item.reqTime = getFormattedDate(item.visit.reqtime);
    item.status = item.visit.status;
    if (item.visit.appointment)
      item.starttime = getFormattedDate(item.visit.appointment);
    if (item.person?.first_name)
      item.doc = getFullName(item.person.first_name, "", item.person.last_name);
    if (item.counsellor)
      item.Counsellor = getFullName(
        item.counsellor.first_name,
        "",
        item.counsellor.last_name,
      );
    item.category = item.visit.visitflag || item.visit.type || "--";
    item.visitDate = item.visit.visitDate
      ? getFormattedDate(item.visit.visitDate)
      : "--";
    item.appTime =
  item.visit.appthours > 0
    ? formatTime12hr(item.visit.appthours, item.visit.apptminutes)
    : "";
    item.insurance = item.visit.insurance;
    item.doc = buildDoctorLabel(item);
    item.docDept = extractDoctorDepartment(item);
    item.roomName = buildRoomLabel(item);
    item.room = item.room || null;
    item.fileNo = item.fileNo;
    item.maIn = item.id;
  };

  const buttonActions = (item) => {
    if (insurancestatus?.[item.visit.id]) {
      const type = insurancestatus[item.visit.id].type;
      item.insuranceStatus =
        {
          Basic: BASIC,
          UploadDoc: BASIC,
          "Pre Auth Request": PRE_AUTH_REQUEST,
          "Pre Auth Response": PRE_AUTH_RESPONSE,
          "Claim Request": CLAIM_REQUEST,
          "Claim Approval": CLAIM_APPROVAL,
          InvoiceGen: INVOICE,
          BillClear: BILLCLEAR,
        }[type] || BASIC;
    }

    if (billaction?.[item.visit.id])
      item.visit.moveToBillBtnAction = billaction[item.visit.id];
    if (closebtnAcion?.[item.visit.id])
      item.visit.closeBtnAction = closebtnAcion[item.visit.id];
  };

  // Mirrors SearchDocList.js's isDoctorAssignment/getLatestDoctorAssignment so the
  // Doctor column shows the same primary assignment as the Doctor Appointment Details card.
  const normalizeAssignmentValue = (value) => (value ?? "").toString().toLowerCase().trim();

  const isPrimaryDoctorAssignment = (assignment) => {
    const group = normalizeAssignmentValue(assignment?.groupname);
    const type = normalizeAssignmentValue(assignment?.type);
    return (group === "" || group === "primary doctor") && type === "doctor";
  };

  const getLatestDoctorAssignment = (item) => {
    const assignments = item?.visitAssignmentList || [];

    // Only show an active primary doctor assignment in the grid.
    const latestOpen = [...assignments].reverse().find(
      (assignment) =>
        isPrimaryDoctorAssignment(assignment) &&
        (assignment?.targetid || assignment?.targetname) &&
        (normalizeAssignmentValue(assignment?.status) === "open" ||
          normalizeAssignmentValue(assignment?.status) === "active" ||
          !assignment?.status)
    );
    return latestOpen || null;
  };

  const extractDoctorDepartment = (item) => {
    // 1. Check if person object directly has department
    if (item?.person?.department) {
      return item.person.department;
    }

    // 2. Try to resolve from cached doctor details using targetid
    const latestAssignment = getLatestDoctorAssignment(item);
    if (latestAssignment?.targetid) {
      try {
        const doctors = personDetailsService.getDoctorsDetail() || [];
        const targetId = latestAssignment.targetid;
        const fullDoctor = doctors.find(
          (d) =>
            d?.personId == targetId || d?.gvId == targetId || d?.gvid == targetId,
        );
        if (fullDoctor?.department) {
          return fullDoctor.department;
        }
      } catch (e) {
        console.warn("Failed to resolve doctor department:", e);
      }
    }

    // 3. Fallback: check visitAssignmentList for department info
    const assignment = getLatestDoctorAssignment(item);
    if (assignment?.department) {
      return assignment.department;
    }

    return '';
  };

  const getLatestRoomAssignment = (item) => {
    const assignments = item?.visitAssignmentList || [];
    return [...assignments]
      .reverse()
      .find(
        (assignment) =>
          ((assignment?.groupname || "").toLowerCase() === "room" ||
            (assignment?.type || "").toLowerCase() === "room") &&
          (assignment?.targetid || assignment?.targetname)
      );
  };

  const buildDoctorLabel = (item) => {
    const latestAssignment = getLatestDoctorAssignment(item);
    if (latestAssignment?.targetname) {
      return latestAssignment.targetname;
    }

    if (latestAssignment?.targetid) {
      // Try to resolve the numeric id to a doctor name from cached doctor details
      try {
        const doctors = personDetailsService.getDoctorsDetail() || [];
        const targetId = latestAssignment.targetid;
        const fullDoctor = doctors.find(
          (d) =>
            d?.personId == targetId || d?.gvId == targetId || d?.gvid == targetId,
        );
        if (fullDoctor) {
          // buildDoctorOption returns a label with display title + name
          return helperServices.buildDoctorOption(fullDoctor)?.label || fullDoctor.first_name || `Doctor ${targetId}`;
        }
      } catch (e) {
        // ignore and fall back
        console.warn("Failed to resolve doctor name:", e);
      }

      return `Doctor ID: ${latestAssignment.targetid}`;
    }

    return "";
  };

  const buildRoomLabel = (item) => {
    const latestAssignment = getLatestRoomAssignment(item);
    if (latestAssignment?.targetname) {
      return latestAssignment.targetname;
    }

    if (latestAssignment?.targetid) {
      return `Room ${latestAssignment.targetid}`;
    }

    if (Array.isArray(item?.roomList) && item.roomList.length > 0) {
      return item.roomList
        .map((room) => `${room.floorId != null ? `${room.floorId}, ` : ""}${room.roomName}`)
        .join("\n");
    }

    if (item?.room?.roomName) {
      return `${item.room.floorId != null ? `${item.room.floorId}, ` : ""}${item.room.roomName}`;
    }

    return null;
  };

  useEffect(() => {
    console.log("single render useeffect");

    isMountedRef.current = true;

    /** Set page header */
    dispatch(patientActions.setPage("PATIENT_SECTION"));

    /** Remove old cache if switching */
    sessionStorage.removeItem("searchvalue");

    /** Initial load */
    renderVisitLists();
    getCustomerGroupInfo();

    // if (!isMountedRef.current) return;

    // const nextBtn = document.querySelector('.ag-paging-button[ref="btNext"]');

    // const handleNextClick = () => {
    //   if (!isMountedRef.current) return;

    //   // If no text and no date filters → ignore
    //   const { searchString, dateFrom, dateTo } = extractFilters();
    //   if (!searchString && !dateFrom && !dateTo) return;

    //   const api = gridRef.current;
    //   if (!api) return;

    //   const currentPage = api.paginationGetCurrentPage();
    //   const nextPage = currentPage + 1;

    //   const payload = {
    //     bodyParams: {
    //       searchString: searchString || "",
    //       flag: "",
    //     },
    //     dateFrom: dateFrom || "",
    //     dateTo: dateTo || "",
    //     page: nextPage,
    //     pageSize: 16,
    //   };

    //   props.searchPatientResult(payload);
    // };

    // nextBtn?.addEventListener("click", handleNextClick);

    // return () => {
    //   isMountedRef.current = false;
    //   nextBtn?.removeEventListener("click", handleNextClick);
    // };
  }, []); // 🔥 Only ONCE

  //----------------------------------------------------------
  // 2) RUN ONLY WHEN search/date/results CHANGE
  //----------------------------------------------------------
  useEffect(() => {
    if (pageReload) {
      console.log("search render useeffect");
      renderVisitLists();
      // if (!isMountedRef.current) return;

      // const nextBtn = document.querySelector('.ag-paging-button[ref="btNext"]');

      // const handleNextClick = () => {
      //   if (!isMountedRef.current) return;

      //   // Mark user pagination ON
      //   isUserTriggeredRef.current = true;

      //   // Let AG-Grid move to next page
      //   const api = gridRef.current;
      //   if (!api) return;

      //   const currentPage = api.paginationGetCurrentPage();
      //   api.paginationGoToPage(currentPage + 1);
      // };

      // nextBtn?.addEventListener("click", handleNextClick);

      // return () => {
      //   isMountedRef.current = false;
      //   nextBtn?.removeEventListener("click", handleNextClick);
      // };
    }
  }, [searchListResult, pageReload, patientsList]);

  //----------------------------------------------------------
  // 3) Unmount cleanup
  //----------------------------------------------------------
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const getCustomerGroupInfo = () => {
    dispatch(
      patientActions.getCustomerGroupInfo((resCb) => {
        if (isMountedRef.current && resCb) {
          setCustomerGroup(resCb.customerGroupInfo || []);
        }
      }),
    );
  };

  // const getFullName = (fname = "", mname = "", lname = "") => {
  //   const pfname =
  //     (fname || "").charAt(0).toUpperCase() + (fname || "").slice(1);
  //   const pmname =
  //     (mname || "").charAt(0).toUpperCase() + (mname || "").slice(1);
  //   const plname =
  //     (lname || "").charAt(0).toUpperCase() + (lname || "").slice(1);

  //   if (fname && lname) return `${pfname} ${plname}`;
  //   if (fname && mname) return `${pfname} ${pmname}`;
  //   if (fname && mname && lname) return `${pfname} ${pmname} ${plname}`;
  //   return `${pfname}      `;
  // };

  const getFullName = (fname = "", mname = "", lname = "") => {
    return [fname, mname, lname].filter(Boolean).join(" ");
  };

  const context = { componentParent: handleRendererCall };

  const rowStyle = { background: "white" };
  const getRowStyle = (params) => {
    if (params.data?.visit?.meetingStatus === "completed")
      return { background: "lightblue" };
  };

  const onGridReady = (e) => {
    gridRef.current = e.api;
    currentPageRef.current = e.api.paginationGetCurrentPage();
    if (isVisitListLoading) e.api.showLoadingOverlay();
    else if (typeList.length === 0) e.api.showNoRowsOverlay();
    else e.api.hideOverlay();
  };

  const onFirstDataRendered = () => {
    if (gridRef.current) {
      const rowCount = gridRef.current.getDisplayedRowCount();
      if (isVisitListLoading) gridRef.current.showLoadingOverlay();
      else if (rowCount === 0) gridRef.current.showNoRowsOverlay();
      else gridRef.current.hideOverlay();
    }
  };

  useEffect(() => {
    if (!gridRef.current) return;

    if (isVisitListLoading) gridRef.current.showLoadingOverlay();
    else if (typeList.length === 0) gridRef.current.showNoRowsOverlay();
    else gridRef.current.hideOverlay();
  }, [isVisitListLoading, typeList]);

  const handlePaginationChanged = (event) => {
    if (!event.newPage || !gridRef.current) return;
    currentPageRef.current = gridRef.current.paginationGetCurrentPage();
  };

  // const getRowHeight = (params) => (params.node.data.appTime ? 55 : 35);
const getRowHeight = (params) => {
  const roomName = params.node.data.roomName || "";
  const hasMultipleRooms = roomName.includes("\n");
  const isLongRoom = roomName.length > 20;
  
  if (params.node.data.appTime) {
    return hasMultipleRooms || isLongRoom ? 75 : 55;
  }
  return hasMultipleRooms || isLongRoom ? 55 : 35;
};

  const closeAlert = () => {
    setServerRes({ success: "", error: "" });
    renderVisitLists();
  };

  const toggleCancel = () => {
    cancelAppointmentDetails.pop();
    setCancelAppt(false);
  };

  const cancelAppointment = (data, item) => {
    let doctor = "",
      vaId = "",
      type = "";
    cancelAppointmentDetails.push(item);

    for (const assignVisit of item.visitAssignmentList) {
      if (
        assignVisit.type.toLowerCase() === "doctor" &&
        assignVisit.targetid &&
        assignVisit.status === "open"
      ) {
        doctor = assignVisit.targetid;
        vaId = assignVisit.id;
        type = "doctor";
        break;
      } else if (
        assignVisit.type === "Counsellor" &&
        assignVisit.targetid &&
        assignVisit.status === "open"
      ) {
        doctor = assignVisit.targetid;
        vaId = assignVisit.id;
        type = "counsellor";
        break;
      }
    }

    let doctorName = "";
    if (type.toLowerCase() === "doctor") {
      const p = item.person;
      doctorName = `${p.displaytitle}. ${p.first_name} ${p.last_name} Dept of ${p.department} (${p.qualification})`;
    } else if (type === "counsellor") {
      const c = item.counsellor;
      doctorName = `${c.displaytitle}. ${c.fname} ${c.last_name} Dept of ${c.department} (${c.qualification})`;
    }
    setShowDoctor(doctorName);

    toCancelSlot.gvid = doctor;
    toCancelSlot.type = "Doctor";
    toCancelSlot.patientId = item.id;
    toCancelSlot.date = item.visit.apptdate || item.visit.capptdate;
    toCancelSlot.vaid = vaId;

    patientDetail.revisitdate = defaultDate;
    setCancelAppt(true);
  };

  const cancel = (action) => {
    if (action !== "CancelVisit") return;

    const ServerResVal = { ...ServerRes };
    patientDetail.closecomment = "NotInSite";
    patientDetail.patientId = cancelAppointmentDetails[0]?.id;
    patientDetail.visitId = cancelAppointmentDetails[0]?.visit.id;
    patientDetail.closescheduleddate = format(new Date(), "yyyy-MM-dd");

    const gvidStr = toCancelSlot.gvid?.toString();
    dispatch(
      patientActions.cancelDoctorCalenderByPatientId(
        { ...toCancelSlot, gvid: gvidStr },
        (resCb) => {
          if (resCb?.successMessages) {
            dispatch(
              patientActions.updateVAStatus(patientDetail, (resCb2) => {
                if (resCb2) {
                  ServerRes.success = "Appointment cancelled successfully";
                  setServerRes({ ...ServerResVal });
                  setTimeout(closeAlert, 3000);
                }
              }),
            );
          }
        },
      ),
    );
    setCancelAppointmentDetails([]);
    setCancelAppt(false);
  };

  const onValueChange = (value) => {
    setSelectedRadio(value);
  };

  const handleOnChange = (field, event) => {
    switch (field) {
      case "date":
        setSelecteddate(event.target.value);
        setDischargeDateSelect(false);
        break;
      case "revisit":
        patientDetail.revisitdate = event.target.value;
        break;
      case "time":
        setSelectedTime(event.target.value);
        setDischargeDateSelect(false);
        break;
      default:
    }
  };

  const overlayNoRowsTemplate = "No patients found";
  const overlayLoadingTemplate = "Loading...";



  
  return (
    <>
      <div className="m-2">
        {ServerRes.success && (
          <Alert severity="success" className="alert-div">
            {ServerRes.success}
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={closeAlert}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}
        {ServerRes.error && (
          <Alert severity="error" className="alert-div">
            {ServerRes.error}
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={closeAlert}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}
      </div>

      <div className="d-flex justify-content-between flex-wrap align-items-baseline">
        <h5 className="page-title mx-3">List Of Patients</h5>
        <div>
          <span className="patient-list mx-3 my-2 d-flex justify-content-between flex-wrap">
            <Button
              variant={type === "All" ? "contained" : "outlined"}
              color="primary"
              className="mb-1 mr-2 button-patient"
              onClick={() => categoryFilter("All")}
              style={{ textTransform: "none" }}
            >
              All ({countAll})
            </Button>
            <Button
              variant={type === "InPatient" ? "contained" : "outlined"}
              color="primary"
              className="mb-1 mr-2 infocyan button-patient"
              onClick={() => categoryFilter("InPatient")}
              style={{ textTransform: "none" }}
            >
              In Patient ({countIn})
            </Button>
            <Button
              variant={type === "OutPatient" ? "contained" : "outlined"}
              color="primary"
              className="mb-1 mr-2 button-patient"
              onClick={() => categoryFilter("OutPatient")}
              style={{ textTransform: "none" }}
            >
              Out Patient ({countOut})
            </Button>
            <Button
              variant={type === "Walkin" ? "contained" : "outlined"}
              color="primary"
              className="mb-1 mr-2 button-patient"
              onClick={() => categoryFilter("Walkin")}
              style={{ textTransform: "none" }}
            >
              Walkin ({countWalkin})
            </Button>
            {org?.isOnlinePatient?.display && org?.orgCode === "manaswini" && (
              <Button
                variant={type === "OnlinePatient" ? "contained" : "outlined"}
                color="primary"
                className="mb-1 mr-2 button-patient"
                onClick={() => categoryFilter("OnlinePatient")}
                style={{ textTransform: "none" }}
              >
                Online Patient ({countOnline})
              </Button>
            )}
          </span>
        </div>
      </div>

      <div key={reloadData}>
        <div className="p-3 preview">
          <div
            className={`ag-theme-balham ag-style card rounded table mb-0 tcol option`}
            style={{ fontSize: "14px", height: 490, width: "100%" }}
          >
            <AgGridReact
              frameworkComponents={{ BtnCellRenderer }}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              onFirstDataRendered={onFirstDataRendered}
              context={context}
              rowData={typeList}
              columnDefs={IpLists ? columnDefs : OpcoulmnDefs}
              defaultColDef={defaultColDef}
              rowStyle={rowStyle}
              getRowStyle={getRowStyle}
              onCellClicked={getAggriddata}
              onGridReady={onGridReady}
              rowHeight={78}
              // getRowHeight={70}
              overlayNoRowsTemplate={overlayNoRowsTemplate}
              overlayLoadingTemplate={overlayLoadingTemplate}
              onPaginationChanged={handlePaginationChanged}
            />
          </div>

          {/* Modals */}
          {AddPatientmodel && (
            <div className="modalmn">
              <Components.AddPatientmodel onModalClose={closeModal} />
            </div>
          )}
          {showPatientVisitModal && (
            <Components.AppointmentScheduleModal
              from="list"
              patientData={selectPatientData}
              onModalClose={closeModal}
            />
          )}
          {showPatientRevisitModal && (
            <Components.PatientRevisitModal
              patientData={selectPatientData}
              patientRevisitDetails={revisitDetail}
              onModalClose={closeModal}
            />
          )}
          {selectedPatientSummary && (
            <div className="modalmn">
              <Components.Discharge
                patientData={selectPatientData}
                dischargesummary={summary}
                onModalClose={closeModal}
              />
            </div>
          )}
          {movetobill && (
            <Components.MoveToBilling
              visitList={props.visitList}
              open={movetobill}
            />
          )}
        </div>

        {/* Move-to-Bill Dialog */}
        <Dialog
          open={onmodal}
          onClose={toggle}
          className="d-flex w-95 h-90 flex-column-reverse modalDialog"
        >
          <div>
            <DialogTitle>
              Warning!
              <IconButton
                aria-label="close"
                onClick={toggle}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className="billing">
              {[
                "MOVED_TO_BILLING",
                "INVOICE_GENERATED",
                "BILL_CLEARED",
              ].includes(visitList?.visit?.internalStatus) ? (
                <span>
                  Patient {visitList?.fname || ""} already has been sent for
                  Billing. If you need to add/delete services/charges please do
                  it in the Billing module.
                </span>
              ) : (
                <span>
                  Are you sure you want to Move {visitList?.fname || ""}{" "}
                  {visitList?.lname || ""} ({visitList?.id || ""}) to Billing?
                </span>
              )}
            </DialogContent>

            {org?.isAadharNumberMandatory?.forInpatients &&
              (!visitList?.adhar || visitList?.adhar === "") && (
                <div style={{ marginTop: "8px" }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        className="p-2"
                        label="Aadhaar"
                        type="number"
                        inputProps={{ min: 0, max: 999999999999 }}
                        value={aadharValue}
                        placeholder="000011112222"
                        onChange={(e) => {
                          const val = e.target.value.slice(0, 12);
                          setAadharValue(val);
                          if (val.length === 12) setAadharError("");
                        }}
                        error={!!aadharError}
                        helperText={aadharError}
                        fullWidth
                        InputProps={{ style: { height: "35px" } }}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}

            <DialogActions className="moveToBill">
              {[
                "MOVED_TO_BILLING",
                "INVOICE_GENERATED",
                "BILL_CLEARED",
              ].includes(visitList?.visit?.internalStatus) ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={AlreadyMovedBill}
                  style={{ textTransform: "none" }}
                >
                  Cancel
                </Button>
              ) : (
                <div
                  className="mx-3"
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div>
                    {dischargeDate ? (
                      <label style={{ paddingTop: "5px" }}>
                        Patient has the Discharge Date {dischargeDate}{" "}
                        {dischargeTime}
                        <br />
                        Do you want to edit it?
                      </label>
                    ) : (
                      <label style={{ paddingTop: "5px" }}>
                        Select Discharge date:
                      </label>
                    )}
                    <div className="d-flex pl-0 col-lg-7 col-xl-7 col-md-12 col-12">
                      <div className="mr-2">
                        <input
                          name="admissionDate"
                          className="form-control filterin Quantity"
                          type="date"
                          defaultValue={selecteddate}
                          onChange={(e) => handleOnChange("date", e)}
                        />
                      </div>
                      <div className="ml-2">
                        <input
                          name="admissionTime"
                          className="form-control filterin Quantity"
                          type="time"
                          defaultValue={selectedTime}
                          onChange={(e) => handleOnChange("time", e)}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingTop: "10px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={AlreadyMovedBill}
                      style={{ textTransform: "none" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={MoveToBilling}
                      style={{ textTransform: "none" }}
                    >
                      Move To Bill
                    </Button>
                  </div>
                </div>
              )}
            </DialogActions>
          </div>
        </Dialog>

        {/* Patient Close Dialog */}
        {/* <Dialog
          open={patientCloseModal}
          onClose={toggle}
          className="d-flex w-95 h-90 flex-column-reverse modalDialog"
        >
          <div>
            <DialogTitle>
              Warning!
              <IconButton
                aria-label="close"
                onClick={toggle}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className="billing">
              <span>
                Are you sure you want to close the visit of{" "}
                {visitList?.fname || ""} {visitList?.lname || ""} (
                {visitList?.id || ""})?
              </span>
            </DialogContent>
            <DialogActions className="moveToBill">
              <div
                className="mx-3"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: "10px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={cancelPatientClose}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={patientCloseSave}
                    style={{ textTransform: "none" }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </DialogActions>
          </div>
        </Dialog> */}

        <Dialog
          open={patientCloseModal || patientForceCloseModal}
          onClose={toggle}
        >
          <DialogTitle className="mb-1">
            {patientForceCloseModal ? "Force Close Warning!" : "Warning!"}
            <IconButton
              aria-label="close"
              onClick={toggle}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "grey.500",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            {patientForceCloseModal ? (
              <>
                {/* Error List */}
                {errorList?.length > 0 && (
                  <div className="mt-1 mb-2">
                    <strong style={{ color: "#d32f2f" }}>
                      Cannot close the patient  {visitList?.fname || ""} {visitList?.lname || ""} (
                      {visitList?.id || ""}) normally due to the payment is still pending.
                    </strong>

                    {/* <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                      {errorList.map((err, index) => (
                        <li key={index} style={{ color: "#d32f2f" }}>
                          {err}
                        </li>
                      ))}
                    </ul> */}
                  </div>
                )}
                <span className="mt-2">
                  Please select a force close reason to proceed.
                </span>
                {/* Force Close Reason */}
                <FormControl fullWidth size="small" style={{ marginTop: 16 }}>
                  <InputLabel id="force-close-reason-label">
                    Force Close Reason
                  </InputLabel>
                  <Select
                    labelId="force-close-reason-label"
                    value={forceCloseReason}
                    label="Force Close Reason"
                    onChange={(e) => setForceCloseReason(e.target.value)}
                  >
                    {forceCloseReasons.map((reason, index) => (
                      <MenuItem key={index} value={reason}>
                        {reason}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Comment Box */}
                {/* <TextField
                  fullWidth
                  multiline
                  // minRows={2}
                  size="small"
                  label="Comments"
                  placeholder="Enter force close remarks..."
                  value={forceCloseComment}
                  onChange={(e) => setForceCloseComment(e.target.value)}
                  style={{ marginTop: 12 }}
                  required
                /> */}


                <TextField
  fullWidth
  multiline
  size="small"
  label="Comments"
  placeholder="Enter force close remarks..."
  value={forceCloseComment}
  onChange={(e) => {
    setForceCloseComment(e.target.value);
    if (e.target.value.trim()) {
      setForceCloseCommentError("");
    }
  }}
  error={!!forceCloseCommentError}
  helperText={forceCloseCommentError}
  style={{ marginTop: 12 }}
  required
/>

                {/* Confirmation Text */}
                {/* <span style={{ display: "block", marginTop: 16 }}>
                  Are you sure you want to force close the visit of{" "}
                  {visitList?.fname || ""} {visitList?.lname || ""} (
                  {visitList?.id || ""})?
                </span> */}
              </>
            ) : (
              <span>
                Are you sure you want to close the visit of{" "}
                {visitList?.fname || ""} {visitList?.lname || ""} (
                {visitList?.id || ""})?
              </span>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={cancelPatientClose}>Cancel</Button>
            <Button
              color="primary"
              disabled={patientForceCloseModal && !forceCloseReason}
              onClick={
                patientForceCloseModal
                  ? patientForceCloseSave
                  : patientCloseSave
              }
            >
              {patientForceCloseModal ? "Force Close" : "Save"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Show Dependent Dialog */}
        <Dialog
          open={showDependent}
          onClose={toggle}
          className="d-flex w-95 h-90 flex-column-reverse modalDialog"
        >
          <div>
            <DialogTitle>
              Warning!
              <IconButton
                aria-label="close"
                onClick={toggle}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogActions className="moveToBill">
              <div
                className="mx-3"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <label style={{ paddingTop: "5px" }}>
                    {dependentMname} has {dependentsCount} dependent(s). Do you
                    want to keep them and discharge the patient?
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: "10px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={closeDependentModel}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={KeepDependents}
                    style={{ textTransform: "none" }}
                  >
                    Keep Dependant(s)
                  </Button>
                </div>
              </div>
            </DialogActions>
          </div>
        </Dialog>

        {/* Onboard Modal */}
        <Dialog
          id="patientRevisit"
          open={onBoardmodal}
          onClose={toggle}
          className="d-flex w-95 h-90 flex-column-reverse dialog"
        >
          <div>
            <DialogTitle>
              Select Patient Category
              <IconButton
                aria-label="close"
                onClick={toggle}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent style={{ padding: "0px 24px" }}>
              <span>Are you sure to OnBoard a patient?</span>
            </DialogContent>
            <DialogActions
              className="d-flex flex-column align-items-end"
              style={{ paddingTop: "0px" }}
            >
              <RadioGroup
                row
                value={selectedRadio}
                onChange={(e) => onValueChange(e.target.value)}
                className="d-flex w-100 justify-content-between"
              >
                <FormControlLabel
                  value="InPatient"
                  control={<Radio />}
                  label="InPatient"
                />
                <FormControlLabel
                  value="OutPatient"
                  control={<Radio />}
                  label="OutPatient"
                />
                {org?.isOnlinePatient?.display &&
                  org?.orgCode !== ORG_CODES.VEDAMAAYU && (
                    <FormControlLabel
                      value="OnlinePatient"
                      control={<Radio />}
                      label="OnlinePatient"
                    />
                  )}
                {org?.orgCode === ORG_CODES.VEDAMAAYU && (
                  <FormControlLabel
                    value="Walkin"
                    control={<Radio />}
                    label="Walk In"
                  />
                )}
                <FormControlLabel
                  value="Proxy"
                  control={<Radio />}
                  label="Proxy"
                />
           
              </RadioGroup>

              {(selectedRadio === "InPatient" ||
                selectedRadio === "Walkin") && (
                <div
                  style={{
                    flexDirection: "column",
                    padding: "0px 10px",
                    marginRight: "auto",
                  }}
                >
                  <label style={{ paddingTop: "5px", paddingBottom: "20px" }}>
                    Select an Admission Date:
                  </label>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                      <TextField
                        type="date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        defaultValue={selecteddate}
                        onChange={(e) => handleOnChange("date", e)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        type="time"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        defaultValue={selectedTime}
                        onChange={(e) => handleOnChange("time", e)}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}
              <Button
                variant="contained"
                color="primary"
                className="btn-style bottomright mt-2"
                onClick={onboardPatient}
                style={{ textTransform: "none", marginRight: "15px" }}
              >
                Save
              </Button>
            </DialogActions>
          </div>
        </Dialog>

        {/* Room Deallocate Modal */}
        <Dialog
          open={roomDealocateModal}
          onClose={toggle}
          className="d-flex w-95 h-90 flex-column-reverse modalDialog"
        >
          <div>
            <DialogTitle>
              Warning!
              <IconButton
                aria-label="close"
                onClick={toggle}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className="dealocate">
              <span>
                Are you sure you want to deallocate the room and move to
                Billing?
              </span>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={roomDealocate}
                style={{ textTransform: "none" }}
              >
                Deallocate room and Move to Bill
              </Button>
            </DialogActions>
          </div>
        </Dialog>

        {/* Cancel Appointment Modal */}
        <Dialog
          open={cancelAppt}
          onClose={toggleCancel}
          className="d-flex w-95 h-90 flex-column-reverse modalDialog"
        >
          <div>
            <DialogTitle>
              Cancel Confirmation
              <IconButton
                aria-label="close"
                onClick={toggleCancel}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className="dealocate">
              <span>
                You are about to cancel appointment for{" "}
                {cancelAppointmentDetails[0]?.fname} (
                {cancelAppointmentDetails[0]?.id}) with
                {showDoctor} on {cancelAppointmentDetails[0]?.visit?.apptdate}{" "}
                {cancelAppointmentDetails[0]?.visit?.appthours
                  ? `at ${cancelAppointmentDetails[0]?.visit?.appthours}:${cancelAppointmentDetails[0]?.visit?.apptminutes
                  } ${cancelAppointmentDetails[0]?.visit?.appthours >= 12
                    ? "PM"
                    : "AM"
                  }`
                  : ""}
                .
              </span>
              <span style={{ paddingTop: "10px" }}>
                <br />
                <label>Select Follow-up date</label>
                <div className="d-inline-block pl-0 col-lg-7 col-xl-7 col-md-12 col-12">
                  <div className="mr-2" style={{ marginLeft: "10px" }}>
                    <input
                      name="admissionDate"
                      className="form-control filterin Quantity"
                      type="date"
                      defaultValue={patientDetail.revisitdate}
                      onChange={(e) => handleOnChange("revisit", e)}
                    />
                  </div>
                </div>
              </span>
            </DialogContent>
            <DialogActions
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={toggleCancel}
                style={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => cancel("CancelVisit")}
                style={{ textTransform: "none" }}
              >
                Cancel Appointment
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    </>
  );
}

export default PatientListing;
